import { send } from '../../../src/network/network';
import { type SignupResponse } from '../../v2/auth/signup/post/post-api-v2-auth-signup';

type Params = {
  userId: string;
  token: string;
  /**
   * Marks a freemium (guest-flow) signup when this login creates an account.
   * Sent only when true so a standard login/signup payload is unchanged.
   */
  isGuestFlow?: boolean;
};

type FacebookLoginResponse = {
  created: boolean;
  customer: SignupResponse;
};

export function postFacebookLogin({ userId, token, isGuestFlow }: Params) {
  return send<FacebookLoginResponse>({
    path: '/api/facebook_login/',
    method: 'POST',
    body: {
      user_id: userId,
      token,
      // Form-encoded, so the backend reads the string through `is_param_truthy`.
      ...(isGuestFlow === true ? { is_guest_flow: 'true' } : {}),
    },
    headers: new Headers({
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    }),
  });
}
